/* One project's settings, at the Settings address.
 *
 * The project switcher treats `/settings/projects/…` as project-scoped and rewrites the
 * address when someone changes project on a settings page. Only the billing child existed,
 * so the switch landed on a route the tree does not have. This is the page it meant: the
 * same panel `/projects/$projectId/settings` renders, with the trail back to Projects that
 * the Settings workspace expects.
 */

import { createFileRoute } from "@tanstack/react-router";

import { ProjectSettingsPanel } from "../../../workspaces/settings/ProjectSettingsPanel";

export const Route = createFileRoute("/_console/settings/projects/$projectId")({
  component: ProjectSettingsRoute,
});

function ProjectSettingsRoute() {
  const { projectId } = Route.useParams();
  return <ProjectSettingsPanel projectId={projectId} />;
}
